import { apiService } from "./apiService";
import { IRequestLogs } from "../types/audit";

export interface IUploadSearchImageReq {
    searchId: string,
    base64: string,
    provider: string
}

export interface ISearchImageReq {
    key: string,
    searchId: string,
    provider: string,
    email: string
    agencyCode: string
}

export const AuditService = {
    logLogin: (email: string) => {
        return apiService.post('/api/audit/login', { log: { email } }).then(response => {
            return response.data && response.data.lastLogin ? response.data.lastLogin : null;
        });
    },
    getAuditLogs: (request: IRequestLogs, type: "login" | "audit") => {
        return apiService.post('/api/audit/logs', {
            search: request,
            type
        }).then(response => {
            return response.data && response.data.logs ? response.data.logs : [];
        });
    }
}


// WEBPACK FOOTER //
// ./src/share/services/audit.ts